import './components.scss';

const NavigationHeaderItem = (props) => {
  return <span>{props.name}</span>
}

export default NavigationHeaderItem;